(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name fuel.controller:FuelCtrl
     *
     * @description
     *
     */
    angular
        .module('fuel')
        .controller('FuelPricesCtrl', FuelPricesCtrl);

    function FuelPricesCtrl(CommonMasterData, CommonFuelService, FuelPricesService, EventManagerService,
                            MessageService, applicationConstants, PopupManager, CommonLogicService) {
        var vm = this;
        vm.ctrlName = 'FuelPricesCtrl';
        vm.model = {
            initialSearchDone: false,
            editorMode:applicationConstants.EDITOR_STATUS.ADD,
            searchCriteria:{
                airport:null
            },
            pricesList:[],
            masterList:{
                airportList:[],
                supplierList:[]
            },
            selectedPrice:null,
            recordChange:false,
            isElasticLoadingVisible:false
        };

        vm.model.showSearchPanel = true;

        EventManagerService.registerEventListener(EventManagerService.EVENT.DO_ELASTIC_SEARCH, getNextSetOfRecords);

        vm.searchFuelPrices = function (searchParam) {

        	if(!!searchParam){
        		vm.model.searchCriteria.airport = searchParam;
        	}

            if(vm.model.searchCriteria.airport!==null){
                vm.model.pricesList = [];
                vm.model.initialSearchDone=true;
                vm.model.searchCriteria.pageSize = 1000;
                vm.model.searchCriteria.startPosition = 1;
                searchFuelPrice();
            }
        };

        vm.changeEditorField = function (formModel, flag) {
            vm.model.recordChange = true;
            if(flag==='airportCode'){
                vm.model.selectedPrice.fuelSupplierId=null;
                var supList = FuelPricesService.getSupplierByAirport(formModel.airportCode.airPortCode);
                if(supList.length>0){
                    vm.model.masterList.supplierList = FuelPricesService.getSupplierByAirport(formModel.airportCode.airPortCode);
                }else{
                    vm.model.masterList.supplierList = [];
                    MessageService.warning(MessageService.MESSAGES.FLIGHT.NO_SUPPLIERS_FOUND);
                }
            }
            if (flag==='fromDate' && !CommonLogicService.compareDateTime(formModel.fromDate, null,formModel.toDate, null)){
                vm.model.selectedPrice.toDate = formModel.fromDate===""?null:formModel.fromDate;
            }
            if (flag==='toDate' && !CommonLogicService.compareDateTime(formModel.fromDate, null,formModel.toDate, null)){
                vm.model.selectedPrice.toDate = formModel.fromDate;
            }
            if (flag === 'fuelPricePerMTonInUSD') {
                limitDecimalPrice();
            }
            if (flag === 'rate') {
                limitDecimalRate();
            }
        };

        function limitDecimalPrice() {
            var value = vm.model.selectedPrice.fuelPricePerMTonInUSD;
            if ((value !== " ") && value.toString().split(".").length > 1 && (value.toString().split(".")[1].length) > 2) {
              vm.model.selectedPrice.fuelPricePerMTonInUSD = value.slice(0, value.indexOf(".")+3);
            }
        }

        function limitDecimalRate (){
            var value = vm.model.selectedPrice.currencyRatePerUSD;
            if((value !== " ") && value.toString().split(".").length > 1 && value.toString().split(".")[1].length > 2) {
              vm.model.selectedPrice.currencyRatePerUSD = value.slice(0, value.indexOf(".") + 3);
            }
        }

        vm.addNewFuelPrices = function () {
            vm.model.editorMode =  applicationConstants.EDITOR_STATUS.ADD;
            vm.model.selectedPrice = FuelPricesService.getNewPrice();
            //loadFuel suppliers
            var params = {};
            params.companyName = null;
            params.companyAbbr = null;
            params.cities = null;
            params.status = 'ACT';
            vm.model.masterList.supplierList = loadFuelSuppliers(params, setDefault);
        };

        vm.submitFuelPrice = function (action, selectedItem) {
            vm.model.selectedPrice = selectedItem;
            if (action === applicationConstants.EDITOR_STATUS.DELETE){
                //set to delete supplier
                var param = {
                    title: 'Confirmation',
                    messages: ["Do you want to delete this record"],
                    flags: selectedItem
                };
                PopupManager.openModal('CONFIRM_DIALOG', param, confirmDeleteDialog);
            }else{
                //set to save supplier update or add new
                saveFuelPrice();
            }
        };

        vm.selectAPrice = function (selectedRowData) {
            vm.model.editorMode =  applicationConstants.EDITOR_STATUS.EDIT;
            vm.model.masterList.supplierList = FuelPricesService.getSupplierByAirport(selectedRowData.airportCode);
            vm.model.selectedPrice = FuelPricesService.getFuelPriceForEdit(selectedRowData);
        };

        function setDefault() {
            var default_Airport = {airPortCode:""};
            vm.model.masterList.airportList.unshift(default_Airport);
            vm.model.searchCriteria.airport = default_Airport;
            var supplierCopy = angular.copy(vm.model.masterList.supplierList);
            FuelPricesService.setSupplierCopy(supplierCopy);
            //  vm.searchFuelPrices();
        }

        function searchFuelPrice() {
            showLoader(true);
            FuelPricesService.setPricesSearchCriteria(vm.model.searchCriteria);
            FuelPricesService.getFuelPrices(
                function (pricesList) {
                	vm.model.showSearchPanel = false;
                    updateFuelPrices(pricesList);
                    showLoader(false);
                },
                function (error) {
                    MessageService.error(error);
                    showLoader(false);
                }
            );
        }

        function showLoader(flag) {
            EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, {
                flag: flag,
                target: 'fuelPrice',
                animationName: 'crewing-loader'
            });
        }

        function updateFuelPrices(pricesList) {
            angular.forEach(pricesList, function (fuelPrice) {
                vm.model.pricesList.push(fuelPrice);
            });
            vm.model.isElasticLoadingVisible= false;
        }

        function getNextSetOfRecords() {
            vm.model.searchCriteria.startPosition = vm.model.searchCriteria.startPosition + vm.model.searchCriteria.pageSize;
            vm.model.isElasticLoadingVisible = true;
            searchFuelPrice();
        }

        function loadFuelSuppliers(param, successFn) {
            FuelPricesService.getFuelSuppliers(param,
                function(response){
                    vm.model.masterList.supplierList = response;
                    if((vm.model.masterList.supplierList.length===0) && (vm.model.masterList.airportCode===' ')){
                        MessageService.warning(MessageService.MESSAGES.FLIGHT.NO_SUPPLIERS_FOUND);
                    }else{
                        if(successFn!==null){
                            successFn();
                        }
                    }
                },
                function (error) {
                    MessageService.error(error.error[0]);
                }
            );
        }

        function saveFuelPrice() {
            FuelPricesService.saveFuelPrice(vm.model.selectedPrice,
                function (response) {
                    if(response.success){
                        MessageService.success('Successfully saved the record!');
                        vm.searchFuelPrices();
                        vm.addNewFuelPrices();
                    }else{
                        MessageService.error(response.errors[0]);
                    }
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        }

        function confirmDeleteDialog(pass) {
            if(pass==='YES'){
                FuelPricesService.deleteFuelPrice(vm.model.selectedPrice,
                    function (response) {
                        MessageService.success('Successfully deleted the record!');
                        vm.searchFuelPrices();
                        vm.addNewFuelPrices();
                    },
                    function (error) {
                        MessageService.error(error);
                    }
                );
            }
        }

        //load city list
        CommonMasterData.getAirportList(function (airportList) {
            vm.model.masterList.airportList = airportList;
            vm.model.masterList.supplierList = [];
            CommonFuelService.setCityList(airportList);
            //vm.model.searchCriteria = FuelPricesService.getPricesSearchCriteria();
            vm.model.selectedPrice = FuelPricesService.getNewPrice();
            //loadFuel suppliers
            var params = {};
            params.companyName = null;
            params.companyAbbr = null;
            params.cities = null;
            params.status = 'ACT';
            loadFuelSuppliers(params, setDefault);
            // loadFuelSuppliers(params);
        }, function () {
        });


    }
}());
